import type { Messages } from '../messages.js'

/**
 * Basque. `jokaldi` for flips, the word a Basque board game uses for a move.
 *
 * Basque is not related to anything else in this file, and it shows in the word order: the verb
 * comes last, so several of these read back to front against their neighbours here. `Hitz bat
 * osatzeko` is `to make up a word`, in that order.
 */
export const eu: Messages = {
  tag: 'eu',

  readingDictionary: 'Hiztegia irakurtzen…',
  noWordList: '"{language}" hizkuntzarako hitz-zerrendarik ez. Sortu bat:  pnpm dictionary build',
  emptyWordList: '"{language}" hizkuntzaren hitz-zerrenda hutsik dago.',

  flips: 'jokaldiak',
  score: 'puntuak',
  words: 'hitzak',
  round: 'txanda',
  ticksLeftLabel: 'Txanda honetan geratzen den denbora',
  typeAWord: 'idatzi hitz bat',
  tapPrompt: 'ukitu letrak hautatzeko edo itzultzeko, gero {action}',

  boardOfTiles: '{n} fitxako taula',
  faceDown: 'ahoz behera',
  wildCard: 'komodina',
  wildKey: 'edozein letra',
  letterReplaced: '{from} {to} bihurtu da',
  letterSwap: 'LETRA-ALDAKETA!',
  spentTile: 'erabilitako fitxa',
  hiddenWhilePaused: 'etenaldian ezkutatuta',
  letterInWord: '{letter}, hitzaren {position}. letra',

  completeWord: 'Osatu hitza',

  completeShort: 'Osatu',
  reset: 'Garbitu',
  pause: 'Eten',
  resume: 'Jarraitu',
  newGame: 'Partida berria',
  paused: 'Etenda',
  outOfFlips: 'Jokaldirik gabe',
  finalResult: '{score} {words} egiteagatik, {rounds} bitartean',
  playAgain: 'Jokatu berriro',
  share: 'Partekatu',
  shareCopied: 'Kopiatuta.',
  shareSelect: 'Kopiatu hau:',

  lettersSelect: 'letrek hautatzen dute',
  keysWild: 'hartzen da fitxa batek erakusten ez duen letra bat idazten duzunean',
  clearsEvery: 'hautatutako {letter} guztiak garbitzen ditu',
  undoLastLetter: 'desegin azken letra',
  noWordsYet: 'Oraindik hitzik ez.',

  wordRejected: '{word}  {reason}',
  reasonDuplicate: 'jada aurkituta',
  reasonTooShort: 'laburregia',
  reasonNotAWord: 'ez da hitza',
  reasonAllFound: 'guztiak dituzu jada',
  noSuchLetterUp: 'ez dago {letter} agerian',
  nothingUp: 'ez dago ezer agerian',
  letterHidden: 'letra bat ezkutatu da',
  shuffled: 'nahastuta',
  shuffledAndBilled: 'nahastuta, {flips} erabili gabe kobratuta',
  tooFewLetters: 'Letra gutxiegi geratzen dira',

  gameLanguage: 'hizkuntza',
  interfaceLanguage: 'interfazea',
  dictionarySize: '{full} hitzetatik {common} eguneroko',
  filterLanguages: 'Bilatu hizkuntza',
  noMatches: 'Bat ere ez',

  nerdMode: 'zaleen modua',
  rules: 'Arauak',
  difficulty: 'zailtasuna',
  difficultyNames: { easy: 'erraza', medium: 'ertaina', hard: 'zaila', insane: 'eroa' },
  pausedNoBoard: 'Partida hau ez da sailkapenean agertuko.',
  about: 'Honi buruz',
  themeLabel: 'itxura',
  themeNames: { traditional: 'ohikoa', light: 'argia', contrast: 'kontraste handia' },
  tiles: 'fitxak (N)',
  secondsPerTick: 'segundo / taupada',
  holdTicks: 'eusteko taupadak',
  minWord: 'hitzik laburrena',
  startingFlips: 'hasierako jokaldiak',
  wildChance: 'komodinaren aukera',
  replaceChance: 'letra-aldaketaren aukera',
  hideChance: 'letra ezkutatzeko aukera',
  wordCompleteMode: 'hitza osatzean',
  wordCompleteNames: { shuffle: 'nahastu', spend: 'gastatu', keep: 'gorde' },
  flipEconomy: 'jokaldien itzulera',
  flipEconomyNames: {
    none: 'bat ere ez',
    perLetter: 'letra bakoitzeko',
    fibonacci: 'fibonacci',
    overMinimum: 'gutxienekotik gora',
  },
  repeatedLetterKey: 'errepikatutako letraren tekla',
  keySchemeNames: { cycle: 'zikloa', advance: 'aurrera' },
  keySchemeHelp: {
    cycle:
      'A-k erabili gabeko hurrengo A hartzen du, eta denak hitzean daudenean, garbitu egiten ditu. ' +
      'Shift+A-k ere garbitzen ditu.',
    advance:
      'A-k erabili gabeko hurrengo A hartzen du. Shift+A-k hitzeko A guztiak garbitzen ditu.',
  },

  whatThatMeans: 'Zer esan nahi duen',
  factRound: 'txanda',
  factWholeBoardUp: 'taula osoa agerian',
  factRoundCosts: 'txanda batek balio du',
  factFlipsBuy: 'hasierako jokaldiek erosten dute',
  factThisBoard: 'taula hau',
  factBoardHadToAdmit: 'taulak onartu behar zuen',
  ticksAndSeconds: '{ticks}, {seconds}',
  wordsLongest: '{words}, luzeena {longest}',
  wordsIncludingOneOf: '{words}, horietako bat {ceiling}',
  scorelessRounds: '{rounds} punturik gabe',

  whatAWordPays: 'Zenbat balio duen hitz batek',
  columnLetters: 'letrak',
  columnCost: 'kostua',
  columnPoints: 'puntuak',
  columnFlips: 'jokaldiak',
  columnNet: 'garbia',

  canonicalRules: '{difficulty} mailako arau arruntak.',
  customRules: 'Aurrezarpenetik aldatuta. Arau propioekin lortutako puntuak ez dira sailkatzen.',
  applyAndStart: 'Aplikatu eta hasi partida berria',
  changesNextGame: 'Aldaketak hurrengo partidan sartuko dira indarrean.',
  presets: 'Aurrezarpenak:',

  start: 'Hasi',
  restart: 'Berrabiarazi',
  quit: 'Utzi',
  quitTitle: 'Partida hau utzi nahi duzu?',
  restartTitle: 'Partida hau berrabiarazi nahi duzu?',
  restartConfirm: 'Berrabiarazi',
  quitConfirm: 'Utzi',
  keepPlaying: 'Jarraitu jokatzen',
  personalBest: 'Zure partidarik onenak',
  newPersonalBest: 'Marka pertsonal berria.',
  columnRank: '#',
  notRanked: 'Arau propioak, beraz partida hau ez da sailkatzen.',
  notRankedPaused: 'Erlojua gelditu da, beraz partida hau ez da sailkatzen.',
  rankOfTotal: '{total}(e)tik {rank}.',

  howToPlay: 'Nola jokatu',

  backToGame: 'Itzuli partidara',
  welcomeTitle: 'Ongi etorri Blinkered-era',
  tutorialSkip: 'Saltatu',
  tutorialNext: 'Hurrengoa',
  tutorialBack: 'Atzera',
  tutorialStart: 'Hasi jokatzen',
  tutorialHideAgain: 'Ez erakutsi hau berriro',
  tutorialProgress: '{total}(e)tik {n}.',
  tutorialSkipTitle: 'Aurkezpena saltatu?',
  tutGoalTitle: 'Blinkered lasterketa bat da',
  tutGoalBody:
    'Partida jokaldi kopuru finko batekin hasten duzu, eta biratzen den fitxa bakoitzak jokaldi bat balio du. Jokaldiak amaitzean, partida amaitu da. Hitzek jokaldiak ematen dituzte, eta zenbat eta luzeagoa hitza, orduan eta jokaldi gehiago irabazten duzu.',
  tutSpentBody:
    'Hitz batean erabiltzen dituzun letrak ahoz behera geratzen dira hurrengo txandara arte. Letra aldaketa batek bakarrik aldatzen du taulan zein letra dauden.',
  tutChangeTitle: 'Letrak alda daitezke',
  tutSameLetters:
    'Jokatzeko denborarik izan ez duzun hitz bat ikusi duzu? Letra berak hurrengo txandan itzultzen dira, leku berrietara nahastuta.',
  tutPickLetters: 'Ukitu nahi dituzun letrak, ordenan, hitz bat osatzeko.',
  tutMoreTurn:
    'Fitxak biratzen jarraitzen dute pentsatzen ari zaren bitartean, beraz letra hobea etor daiteke oraindik.',
  tutTapBack:
    'Nahi ez zenuen bat hartu duzu? Ukitu berriro itzultzeko. Edozein, ez azkena bakarrik.',
  tutComplete: 'Sakatu Osatu hitza prest dagoenean.',
  htBoardTitle: 'Taula',
  htBoardBody:
    'Fitxak banaka biratzen dira, ausazko ordenan. Agerian daudenekin hitzak osatzen dira.',
  htWordsTitle: 'Hitzak',
  htWordsBody: 'Osatu hitz bat agerian dauden fitxekin, letrak ordenan idatziz edo sakatuz.',
  htFlipsTitle: 'Jokaldiak',
  htFlipsBody:
    'Biratzen den fitxa bakoitzak jokaldi bat balio du. Osatutako hitz batek jokaldiak itzultzen ditu, eta hitz luzeagoek gehiago. Jokaldiak amaitzean, partida amaitu da.',
  htRoundTitle: 'Txanda',
  htRoundBody:
    'Txandako azken fitxa biratzean, taula osoa une batez geratzen da. Gero fitxak itzuli eta nahasten dira, eta txanda berri bat hasten da.',
  htLanguagesTitle: 'Hizkuntzak',
  htLanguagesBody:
    '{n} dira. Taula oro ebatz daiteke jendeak benetan erabiltzen dituen hitzekin. Hitz arraro batek ere puntuak ematen ditu, hiztegiak ezagutzen badu.',
  htKeysTitle: 'Teklatua',
  htWildTitle: 'Komodinak',
  htWildBody:
    'Batzuetan komodin bat agertzen da letra baten ordez. Komodinak hitz zuzena osatzen duen edozein letra balio du. Jada osatutako hitz batek ez du balio.',
  htHideTitle: 'Ezkutatzen diren letrak',
  htHideBody:
    'Maila zailenetan agerian dagoen letra bat bere kabuz itzul daiteke eta geroago itzuliko da txandan. Kronometroak tic bat gehiago jasotzen du horretarako, gorriz. Jada hautatutako letrak ez dira itzultzen.',
  tutHideBody:
    'Maila zailenetan agerian dagoen letra bat bere kabuz itzul daiteke eta geroago itzuliko da txandan. Jada hautatutako letrak ez dira itzultzen.',
  htSwapTitle: 'Aldatzen diren letrak',
  htSwapBody:
    'Batzuetan, txanden artean, letra bat beste batekin ordezkatzen da. Zein joan den eta zein etorri den ikusiko duzu.',
  htLevelsTitle: 'Mailak',
  htLevelEasy:
    'Hamabi letra berberak partida osoan, beraz ikas ditzakezu eta hitz-zerrenda bat buruan eraman. Fitxak astiro biratzen dira, eta taula osoa nahikoa denboran ikusgai geratzen da aukeraketa bukatzeko.',
  htLevelMedium:
    'Noizean behin letra bat aldatzen da, beraz zailagoa da geroko gordetako hitzak gogoratzea. Denbora gutxiago begiratzeko eta gutxiago pentsatzeko.',
  htLevelHard:
    'Hiru letrako hitzek ez dute gehiago balio, eta letra bat txandaz txanda aldatzen da gutxi gorabehera. Taula erakutsi orduko nahasten da.',
  htLevelInsane:
    'Dena batera, abiadura betean. Taula azken jokaldiaren ondoren berehala nahasten da.',
  htTouchTitle: 'Ukipen-pantaila',
  htTouchBody:
    'Ukitu agerian dagoen fitxa bat bere letra hartzeko. Ukitu hartutako letra bat itzultzeko. Osatu eta Garbitu taularen azpian daude.',

  accountTitle: 'Zure kontua',
  menuProfile: 'Nire profila',
  menuGames: 'Nire partidak',
  menuPublicPage: 'Nire orri publikoa',
  menuSignedInAs: 'Saioa hasita honela',
  signIn: 'Hasi saioa',
  signOut: 'Amaitu saioa',
  signInTitle: 'Hasi saioa edo izena eman',
  signInLead: 'Kontu batek zure partidak gordetzen ditu, gailu guztietan.',
  signInKeepGame: 'Hasi saioa partida hau gordetzeko, eta ondorengo guztiak.',
  continueWithApple: 'Jarraitu Apple-rekin',
  continueWithGoogle: 'Jarraitu Google-rekin',
  signInOr: 'edo',
  emailLabel: 'Helbide elektronikoa',
  codeLabel: 'Kodea',
  emailMeACode: 'Bidali kode bat',
  working: 'Une bat…',
  sendNewCode: 'Bidali kode berri bat',
  codeSent: 'Begiratu posta. Kodeak 10 minutu irauten du.',
  notNow: 'Orain ez',
  badEmail: 'Horrek ez dirudi helbide elektroniko bat.',
  badCode:
    'Kode horrek ez du funtzionatu. Kodeak 10 minututan iraungitzen dira eta behin balio dute.',
  serverBusy: 'Ezin izan da zerbitzariarekin konektatu. Saiatu berriro une batean.',
  serverDown: 'Ezin izan da zerbitzariarekin konektatu.',
  offline: 'Konexiorik gabe',
  leaderboardTitle: 'Sailkapena',
  leaderboardEmpty: 'Oraindik ez dago partidarik sailkapen honetan. Izan zaitez lehena.',
  leaderboardWouldBe: 'Non egongo litzateke partida hau',
  leaderboardThisGame: 'Partida hau',
  leaderboardRanksHere: 'Non dago partida hau',
  leaderboardOutside: 'Lehen bostetik kanpo.',
  tutAccountTitle: 'Gorde zure puntuazioak',
  tutAccountBody:
    'Kontu batek zure partidak gordetzen ditu, puntuazioak sailkapenean jartzen eta zure profila mantentzen.',
  ssoCancelled: 'Saio-hasiera bertan behera utzi da.',
  ssoExpired: 'Luzeegi jo du. Hasi saioa berriro.',
  ssoNoUsername: 'Ezin izan da kontua sortzen amaitu. Saiatu berriro une batean.',
  ssoFailed: 'Ez du funtzionatu. Saiatu berriro, edo erabili posta.',
  tabProfile: 'Profila',
  countryAny: 'Nahiago dut ez esan',
  findCountry: 'Bilatu herrialdeak',
  usernameLabel: 'Erabiltzaile-izena',
  bioLabel: 'Niri buruz',
  countryLabel: 'Herrialdea',
  bioHint: 'Estekarik ez. {left}/{max}',
  save: 'Gorde',
  saving: 'Gordetzen…',
  saved: 'Gordeta.',
  nameTaken: 'Izen hori norbaitek badu.',
  nameTooShort: 'Pixka bat luzeagoa, mesedez.',
  nameTooLong: 'Luzeegia da.',
  nameBadCharacters: 'Letrak, zifrak, marratxoak eta azpimarrak soilik.',
  nameBadEdges: 'Letra edo zifra batekin hasi eta amaitu behar du.',
  nameMixedScripts: 'Aukeratu alfabeto bakarra eta jarraitu horrekin.',
  nameReserved: 'Guk banatzen ditugun izenen antza du. Aukeratu beste bat.',
  nameUnusable: 'Izen hori ezin da erabili.',
  bioTooLong: 'Eremu honek {max} karaktere hartzen ditu gehienez.',
  bioHasLink: 'Hemen ez da estekarik onartzen.',
  bioHasControl: 'Hemen sartu ezin diren karaktereak ditu.',
  bioUnusable: 'Testu hori ezin da erabili.',
  gamesHeading: 'Partidak',
  gamesEmpty:
    'Oraindik ez dago ezer hemen. Saioa hasita jokatzen dituzun partidak hemen agertuko dira.',
  gamesEmptyShort: 'Oraindik ez dago ezer hemen.',
  gamesLoading: 'Zure partidak irakurtzen…',
  theirGamesLoading: 'Haien partidak irakurtzen…',
  profileLoading: 'Profila irakurtzen…',
  playerNotFound: 'Hemen ez dago inor izen horrekin.',
  columnWhen: 'Noiz',
  columnRounds: 'txanda',
  columnGame: 'Partida',
  gameLoading: 'Partida irakurtzen…',
  gameUnreadable: 'Ezin izan da partida hau irakurri.',
  gameNotRanked: 'Arau aldatuekin jokatua, beraz ez da sailkatzen.',
  detailNotKept: 'Partida honen hitzak eta taulak ez dira gehiago gordetzen.',
  openingBoard: 'Hasierako taula',
  roundByRound: 'Txanda txandaka',
  roundNothing: 'ez da ezer aurkitu',
  changeReplaced: '{letter} ordeztua {slot} laukian',
  changeWildOn: '{letter} komodina {slot} laukian',
  changeWildOff: '{letter} komodina kendua {slot} laukitik',
  keepThisGame: 'Gorde partida hau',
  savedToYourGames: 'Zure partidetan gordeta.',

  reportThis: 'Salatu',
  reportHeading: 'Hau salatu',
  reportTheName: 'Izena',
  reportTheBio: 'Aurkezpena',
  reportTheScore: 'Puntuazioa',
  reportWhy: 'Zer du txarra? Aukerakoa.',
  reportSend: 'Bidali salaketa',
  reportSent: 'Eskerrik asko. Norbaitek begiratuko dio.',
  reportSignIn: 'Hasi saioa zerbait salatzeko.',
  reportGone: 'Hori jada ez dago.',
  reportCancel: 'Utzi',

  deleteAccount: 'Ezabatu nire kontua',
  deleteAccountWhat:
    'Honek zure profila eta gorde dituzun partida guztiak ezabatzen ditu, betiko. Ezin da desegin.',
  deleteAccountAsk: 'Bidali kode bat',
  deleteConfirm: 'Ezabatu betiko',
  deleteGone: 'Zure kontua joan da. Eskerrik asko jolasteagatik.',
  deleteNoAddress:
    'Kontu honek ez du helbide baieztaturik, beraz ezabatzea ezin da egiaztatu. Jarri gurekin harremanetan eta eskuz egingo dugu.',

  rulesetFacts: '{letters} hitzak · fitxa berri bat {seconds}',
  plurals: {
    words: { one: 'hitz {n}', other: '{n} hitz' },
    rounds: { one: 'txanda {n}', other: '{n} txanda' },
    flips: { one: 'jokaldi {n}', other: '{n} jokaldi' },
    ticks: { one: 'taupada {n}', other: '{n} taupada' },
    points: { one: 'puntu {n}', other: '{n} puntu' },
    minLetters: { one: 'letra {n} edo gehiagoko', other: '{n} letra edo gehiagoko' },
    seconds: { one: '{n} segundoro', other: '{n} segundoro' },
  },
}
